/**
 * 处理ins与cg api的加密
 * 写在同一文件夹避免重复引入crypto-js
 */
import CryptoJS from "crypto-js";
import { getDeviceInfo, getIDFA } from "@/utils/js_bridge_info";
import INS_APP_INFO from "@/api/ins_api/ins_api_consts/ins_api_app_info_consts";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import AES from "crypto-js/aes";
import Hex from "crypto-js/enc-hex";
import HmacSHA512 from "crypto-js/hmac-sha512";
import MD5 from "crypto-js/md5";
// import CryptoJS from "crypto-js/core";

// const Base64 = require("crypto-js/enc-base64");
// const Utf8 = require("crypto-js/enc-utf8");
// const AES = require("crypto-js/aes");
// const Hex = require("crypto-js/enc-hex");
// const HmacSHA512 = require("crypto-js/hmac-sha512");
// const MD5 = require("crypto-js/md5");
// const CryptoJS = require("crypto-js/crypto-js");

const key = Utf8.parse("9vApxLk5G3PAsJrM");
const iv = Utf8.parse("FnJL7EDzjqWjcaY9");
const zvKey = "gps";
const encryptVersion = "I3";

// =======================  cg api的加密  ===========================

/**
 * cg api 参数加密
 * @param str
 */
const encrypt = (str: any) => {
  const aes: any = AES.encrypt(JSON.stringify(str), key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return aes.ciphertext.toString();
};
/**
 * 获取加密后的数据
 * @param str
 */
export const getEncryptData = (str: any) => {
  return {
    zv: zvKey,
    data: encryptVersion + encrypt(str)
  };
};

/**
 * cg api response解密
 * @param word
 */
export const decrypt = (word: any) => {
  const encryptedHexStr = Hex.parse(word);
  const srcs = Base64.stringify(encryptedHexStr);
  const result = AES.decrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = result.toString(Utf8);
  return decryptedStr.toString();
};

/**
 * obejct to base64
 * @param data
 */
export const base64Object: (data: any) => string = (
  data: object | undefined
) => {
  return btoa(JSON.stringify(data));
};

// base64转成json
export const base64ToJson = (data: any) => {
  const words = Base64.parse(data);
  const textString = Utf8.stringify(words);
  return JSON.parse(textString);
};

export const base64ToString = (data: any) => {
  const words = Base64.parse(data);
  const textString = Utf8.stringify(words);
  return textString;
}

// pinad请求加密header
export const cryptoBodyOrParams = (word: string) => {
  return HmacSHA512(word, key).toString();
};
/**
 * pinad 对device id加密
 */
export const deviceId = () => {
  const deviceInfo = getDeviceInfo();
  // 如果存在idfa且不为0，则直接md5加密，否则需要自己拼接然后md5加密
  if (getIDFA() !== "00000000-0000-0000-0000-000000000000") {
    return MD5(getIDFA()).toString();
  } else {
    const datajson = {
      name: deviceInfo.device.name,
      system: deviceInfo.device.system_name,
      system_version: deviceInfo.device.system_version,
      model: deviceInfo.device.model,
      localmodel: deviceInfo.device.localized_model,
      country: deviceInfo.locale.country_code,
      language: deviceInfo.locale.language_code,
      ip: deviceInfo.device_ip
    };
    return MD5(JSON.stringify(datajson)).toString();
  }
};

// ==========================ins api的加密===============================

export const insSignBody = (jsonBody: any) => {
  const body = jsonBody || {};
  let bodyString = JSON.stringify(body);
  bodyString = bodyString || "";

  const signBody = (bodystr: string, key1: string, key2: string) => {
    const signKey1 = Base64.parse(key1);
    const signKey2 = Base64.parse(key2);
    const bodyStr = Utf8.parse(bodystr);

    let sha256: any = CryptoJS.algo.SHA256.create();
    sha256.update(signKey1);
    sha256.update(bodyStr);
    let hash: any = sha256.finalize();

    sha256 = CryptoJS.algo.SHA256.create();
    sha256.update(signKey2);
    sha256.update(hash);
    hash = sha256.finalize();
    return hash.toString();
  };

  const form: any = {};
  form.ig_sig_key_version = INS_APP_INFO.IG_SIG_KEY_VERSION;
  form.signed_body =
    signBody(bodyString, INS_APP_INFO.SECRET_KEY_1, INS_APP_INFO.SECRET_KEY_2) +
    "." +
    bodyString;
  return form;
};
